"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductAvailability = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var AlertLevelMap = /*#__PURE__*/function (AlertLevelMap) {
  AlertLevelMap[AlertLevelMap["information"] = 0] = "information";
  AlertLevelMap[AlertLevelMap["warning"] = 1] = "warning";
  AlertLevelMap[AlertLevelMap["alert"] = 2] = "alert";
  return AlertLevelMap;
}(AlertLevelMap || {});
var ProductAvailability = exports.ProductAvailability = function ProductAvailability(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var renderMobile = function renderMobile(productAvailability) {
    return productAvailability.doPreventAddToCart ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "col messages d-sm-none prevent-purchase"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "font-weight-bold"
    }, productAvailability.preventPurchaseMessage)) : /*#__PURE__*/_react["default"].createElement("div", {
      className: "col messages d-sm-none"
    }, productAvailability.wbTruckDelivery && /*#__PURE__*/_react["default"].createElement("img", {
      alt: "truck",
      src: "https://images.wbmason.com/65/wb_truck.png"
    }), productAvailability.calloutMessage && /*#__PURE__*/_react["default"].createElement("span", {
      className: "callout-message"
    }, productAvailability.calloutMessage, " "), productAvailability.requiresMessageDescriptions ? /*#__PURE__*/_react["default"].createElement("a", {
      href: "https://www.wbmason.com/PopupPage.aspx?cpi=Availability",
      target: "_blank",
      rel: "noopener noreferrer",
      "aria-label": "availability"
    }, /*#__PURE__*/_react["default"].createElement("span", null, productAvailability.deliveryMessage)) : /*#__PURE__*/_react["default"].createElement("span", null, productAvailability.deliveryMessage));
  };
  function popUp(event) {
    event.stopPropagation();
    var windowPopup = window.open("https://www.wbmason.com/PopupPage.aspx?cpi=Availability", "", "menubar=0,scrollbars=1,toolbar=0,resizable=0,status=0,location=0,width=345,height=400");
    windowPopup.focus();
    windowPopup.moveTo(30, 30);
  }
  var renderDesktop = function renderDesktop(productAvailability) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "d-none d-sm-flex"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "row no-gutters"
    }, productAvailability.doPreventAddToCart ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "col messages prevent-purchase"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "font-weight-bold"
    }, productAvailability.preventPurchaseMessage)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "messages"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "row no-gutters"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-12 callout-message"
    }, productAvailability.calloutMessage && /*#__PURE__*/_react["default"].createElement("span", null, productAvailability.calloutMessage)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "availability-container"
    }, productAvailability.wbTruckDelivery && /*#__PURE__*/_react["default"].createElement("img", {
      alt: "truck",
      src: "https://images.wbmason.com/65/wb_truck.png"
    }), productAvailability.requiresMessageDescriptions ? /*#__PURE__*/_react["default"].createElement("a", {
      className: "wbm-button btn btn-link medium",
      onClick: function onClick(event) {
        return popUp(event);
      },
      "aria-label": "availability"
    }, /*#__PURE__*/_react["default"].createElement("span", null, productAvailability.deliveryMessage)) : /*#__PURE__*/_react["default"].createElement("span", null, productAvailability.deliveryMessage)))))));
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "row no-gutters wbm-product-availability-".concat(AlertLevelMap[props.availabilityInfo.alertLevel]).concat(props.smallText ? " small-text" : ""),
    key: "".concat(props.availabilityInfo.itemId, "-").concat(props.availabilityInfo.itemId, "-availability")
  }, renderDesktop(props.availabilityInfo), renderMobile(props.availabilityInfo));
};
//# sourceMappingURL=productAvailability.js.map